import React, { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";

export const SCThemeProvider = ({ children }: { children: ReactNode }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
